import { keepPreviousData, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { SkillsApi } from '@/lib/api/skills';
import type { Skill } from '@/lib/api/types/skills';
import { capacityQueryKeys } from '@/lib/query-keys/capacity';

export const getSkillsQueryOptions = () => {
  return {
    queryKey: capacityQueryKeys.skills.all(),
    queryFn: async () => {
      return await SkillsApi.getSkills();
    },
  };
};

export const getSearchSkillsQueryOptions = (query: string = '') => {
  return {
    queryKey: capacityQueryKeys.skills.search(query),
    queryFn: () => SkillsApi.searchSkills(query),
    placeholderData: keepPreviousData,
  };
};

export const useSkillsQuery = (options: Partial<UseQueryOptions<Skill[]>> = {}) => {
  return useQuery({ ...getSkillsQueryOptions(), ...options });
};

export const useSearchSkillsQuery = (query: string = '') => {
  return useQuery({ ...getSearchSkillsQueryOptions(query) });
};
